import React from "react";
import moment from "moment-timezone";
import useHelper from "../../hooks/useHelper";
import useLeagueSeason from "../../hooks/queryResults/useLeagueSeason";
import useTeams from "../../hooks/queryResults/useTeams";
import useUsers from "../../hooks/queryResults/useUsers";
import Util from "../../util/util";
import Loading from "../ui/Loading";
import TimeAgo from "../ui/TimeAgo";
import styled from "styled-components";

const StyledDivContainer = styled.div`
  display: flex;
  align-items: center;
  height: 2rem;
  background-color: ${(props) => props.colors?.obj?.first || "lightgray"};
  color: ${(props) => props.colors?.obj?.second || "black"};
  border-top: 0.125rem solid ${(props) => props.colors?.obj?.second || "black"};

  & > div {
    padding: 0 0.25rem;
  }
`;

const StyledDivUserName = styled.div`
  flex-grow: 10;
`;

export default function MessageBar({ message }) {
  const helper = useHelper();
  const { leagueSeason } = useLeagueSeason();
  const { teams, teamsQuery } = useTeams();
  const { users, usersQuery } = useUsers();

  const loading = !leagueSeason || teamsQuery.isLoading || usersQuery.isLoading;

  let user;
  let userName = "";
  if (users) {
    user = users.getUserByUsername(message.obj.fromUser);
    userName = user.fullName;
  }

  let team;
  let teamLogo = null;
  if (message.asCommish()) {
    userName = `Commissioner (${userName})`;
  } else {
    if (message.obj.fromObj && teams) {
      team = teams.getTeamById(message.obj.fromObj);
    }

    if (team && leagueSeason) {
      const currentSeason = Util.getCurrentSeason();
      let week;
      if (leagueSeason.obj.season === currentSeason) {
        week = Util.getCurrentWeek(moment(message.obj.when).toDate());
      } else {
        week = Util.getNumWeeksInNflSeason(leagueSeason.obj.season);
      }
      if (week) {
        teamLogo = helper.getTeamLogoImg(
          team,
          week,
          "sm",
          team.getPath({ week: Util.weekToUrl(week) })
        );
      }

      userName = team.fullName + ` (${userName})`;
    }
  }

  return (
    <StyledDivContainer colors={team?.colors}>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div>{teamLogo}</div>
          <StyledDivUserName>{userName}</StyledDivUserName>
          <div>
            <TimeAgo date={message.obj.when} />
          </div>
        </>
      )}
    </StyledDivContainer>
  );
}
